import { render, staticRenderFns } from "./PartCenter.vue?vue&type=template&id=0c1ff25f&scoped=true"
import script from "./PartCenter.vue?vue&type=script&lang=js"
export * from "./PartCenter.vue?vue&type=script&lang=js"
import style0 from "./PartCenter.vue?vue&type=style&index=0&id=0c1ff25f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ff25f",
  null
  
)

export default component.exports